module.exports = __webpack_public_path__ + "static/media/hero-2.84b10d0b.svg";